import React from "react";
import { Phone } from "lucide-react";
import { companyInfo } from "../mock";

const LandingPageHeader = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#000000] border-b border-[#302f2c]">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-20 sm:h-24">
          {/* Logo - Updated to logo-02.png */}
          <div className="flex items-center">
            <img 
              src="/assets/img/brand/logo-light.png"
              alt="Book Creation Studio"
              className="h-10 sm:h-12 lg:h-14 w-auto"
            />
          </div>

          {/* Phone Number */}
          <a 
            href={`tel:${companyInfo.phone}`} 
            className="flex items-center gap-2 group transition-colors font-semibold text-sm sm:text-base"
          >
            <Phone size={20} strokeWidth={2} className="text-[#F4D03F]" />
            <span className="tracking-tight text-white group-hover:text-[#F4D03F] transition-colors hidden sm:inline">
              {companyInfo.phone}
            </span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default LandingPageHeader;